import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { names } from 'src/constants/Names';
import {
	Button,
	FontAwesome,
	ModalBox,
	ModalBoxFooter,
	SubmitButton
} from 'src/containers/Elements';
import { api } from 'src/helpers/API';
import { toastify } from 'src/helpers/Toastify';
import { useAxios } from 'src/hooks/useAxios';
import { Colors } from 'src/types/Color';

function CloneJob({ jobId }: { jobId: string }) {
	const [confirmClone, setConfirmClone] = useState(false);
	const { t } = useTranslation();
	const { jobs } = names;

	const { sendRequest, isLoading } = useAxios();
	const onCloseModal = () => {
		setConfirmClone(false);
	};
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	const onConfirmClone = async () => {
		await sendRequest(
			api.cloneJob(jobId),
			{
				method: 'POST'
			},
			(jobId) => {
				queryClient.invalidateQueries('jobs');
				toastify('toastify.job-cloned-successfully', {
					type: 'success'
				});
				setConfirmClone(false);

				void navigate(`${jobs.path}/${jobId}`, {
					state: { prevPath: jobs.path }
				});
			}
		);
	};
	return (
		<>
			<Button
				onClick={() => setConfirmClone(true)}
				color={Colors['white-green']}
				className="gap-2 text-nowrap ">
				{t('button.clone')}
			</Button>
			<ModalBox isOpen={confirmClone} onClose={onCloseModal}>
				<header className="d-flex  align-items-baseline justify-content-center text-center gap-2 fs-6">
					<FontAwesome icon="clone" className="text-green" />
					<p className="text-gray-3">
						{t('text.would-you-like-to-clone-this-job')}
					</p>
				</header>
				<ModalBoxFooter className="justify-content-between pt-3">
					<Button
						color={Colors['white-red']}
						label={t('button.cancel') as string}
						onClick={onCloseModal}
					/>
					<SubmitButton
						icon="clone"
						color={Colors['white-green']}
						isSubmitting={isLoading}
						label="button.clone"
						savingLabel="button.clone"
						onClick={onConfirmClone}
					/>
				</ModalBoxFooter>
			</ModalBox>
		</>
	);
}

export default CloneJob;
